function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'ramda/src/isEmpty';
import pathOr from 'ramda/src/pathOr';
import { ADJUSTMENT_CATEGORIES, INVOICE, INVOICE_START_DATE_DURATION, MAX_DESCR_LENGTH, MIN_NOTE_AMOUNT, NOTE_TYPES } from './applyTaxCertificate.modal.constants';
import { constraintErrorMessages } from 'invision-core/src/utilities/angular.form.utilities';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import { CurrentBusinessUnitCurrencyCodeSelector } from 'invision-core/src/components/session/businessunit.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { createConvergentBillerAdjustment, retrieveInvoicesForDropdown } from '../../../reducers/actions/customer.billing.actions';
import * as BillingPaymentsConstants from '../billing.payments.constants';
import { AdjustmentConfigSelector, AdjustmentReasonCodeForTaxSelectionOptions, HierarchyInvoiceNodeSubscriberIdSelector, InvoiceListWithTaxForDropDownSelector, InvoiceSummariesSelector, IsFetchingInvoiceListSelector } from '../../../reducers/selectors/customer.billing.selectors';
import { IsCreatingConvergentBillerAdjustmentSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import LocaleKeys from '../../../locales/keys';
import moment from 'moment';
import { REPORTING_LEVELS } from '../../../components/customer/accountHierarchy/account.hierarchy.constants';
var ApplyTaxCertificateModalController = /*#__PURE__*/function () {
  function ApplyTaxCertificateModalController($ngRedux, $filter, uiNotificationService) {
    _classCallCheck(this, ApplyTaxCertificateModalController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      isStatement: this.isStatement.bind(this),
      MAX_DESCR_LENGTH: MAX_DESCR_LENGTH,
      MIN_NOTE_AMOUNT: MIN_NOTE_AMOUNT,
      NOTE_TYPES: NOTE_TYPES,
      onTaxCertificateDateChanged: this.onTaxCertificateDateChanged.bind(this),
      onInvoiceSelected: this.onInvoiceSelected.bind(this),
      selectedInvoiceNumber: null,
      selectedReasonCode: null,
      taxCertificateDate: moment(),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ApplyTaxCertificateModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentConfig: AdjustmentConfigSelector(store),
          adjustmentReasonCodes: AdjustmentReasonCodeForTaxSelectionOptions(store),
          adjustmentReasonCodesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdjustmentReason, store),
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          hierarchyInvoiceNodeSubscriberId: HierarchyInvoiceNodeSubscriberIdSelector(store),
          invoiceList: InvoiceListWithTaxForDropDownSelector(store),
          invoiceSummaries: InvoiceSummariesSelector(store),
          isCreatingConvergentBillerAdjustment: IsCreatingConvergentBillerAdjustmentSelector(store),
          isFetchingInvoiceList: IsFetchingInvoiceListSelector(store)
        };
      };
      var controllerActions = {
        createConvergentBillerAdjustment: createConvergentBillerAdjustment,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        retrieveInvoicesForDropdown: retrieveInvoicesForDropdown
      };
      this.localeKeys = LocaleKeys;
      this.noteType = NOTE_TYPES.CREDIT;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.adjustmentReasonCodesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AdjustmentReason);
      }
      if (this.state.invoiceSummaries.length) {
        this.currencyCode = this.state.invoiceSummaries[0].CurrencyCode;
      } else {
        this.currencyCode = this.state.currentBusinessUnitCurrencyCode;
      }
      this.enableGenerateStatements = this.state.adjustmentConfig[BillingPaymentsConstants.ENABLE_GENERATE_STATEMENT] === BillingPaymentsConstants.ADJUSTMENT_CONFIG_ENABLED ? true : false;
      this.getInvoiceAndDebitNotesList();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "getInvoiceAndDebitNotesList",
    value: function getInvoiceAndDebitNotesList() {
      var _this2 = this;
      var getInvoiceAndDebitNotesListRequest = {
        customerId: this.state.currentCustomer.Id,
        request: {
          Filter: BillingPaymentsConstants.INVOICES
        }
      };
      this.actions.retrieveInvoicesForDropdown(getInvoiceAndDebitNotesListRequest).then(function () {
        if (_this2.invoiceId) {
          _this2.selectedInvoiceNumber = _this2.state.invoiceList.find(function (invoice) {
            return invoice.id === _this2.invoiceId;
          });
          _this2.onInvoiceSelected();
        }
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "adjustmentReasonCodes",
    get: function get() {
      var _this3 = this;
      var adjustmentReasonCodes = pathOr([], ['adjustmentReasonCodes'], this.state);
      return adjustmentReasonCodes.filter(function (reasonCode) {
        return (reasonCode.adjustment_category === ADJUSTMENT_CATEGORIES.OTHER || isEmpty(reasonCode.adjustment_category)) && (_this3.noteType === reasonCode.adjustment_payment_type || isEmpty(reasonCode.adjustment_payment_type));
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.onClose();
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.formErrorMessages = constraintErrorMessages(undefined, this.applyTaxCertificateForm, {
        taxAmount: LocaleKeys.APPLY_TAX_CERTIFICATE.TAX_AMOUNT,
        taxCertificateDate: LocaleKeys.APPLY_TAX_CERTIFICATE.TAX_CERTIFICATE_DATE,
        taxCertificateNumber: LocaleKeys.APPLY_TAX_CERTIFICATE.WITHHELD_TAX_CERTIFICATE_ID,
        noteDescription: LocaleKeys.ADJUSTMENTS.DESCRIPTIONS,
        reasonCode: LocaleKeys.ADJUSTMENTS.REASON_CODE
      });
    }
  }, {
    key: "onTaxCertificateDateChanged",
    value: function onTaxCertificateDateChanged(taxCertificateDate) {
      this.taxCertificateDate = taxCertificateDate;
      this.validateForm();
    }
  }, {
    key: "onInvoiceSelected",
    value: function onInvoiceSelected() {
      if (this.selectedInvoiceNumber) {
        this.taxAmount = this.selectedInvoiceNumber.taxDueAmount;
        this.validateForm();
      }
    }
  }, {
    key: "isStatement",
    value: function isStatement() {
      var _this$state$currentCu;
      return ((_this$state$currentCu = this.state.currentCustomer) === null || _this$state$currentCu === void 0 ? void 0 : _this$state$currentCu.HierarchyReportingLevel) === REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT;
    }
  }, {
    key: "applyTaxCertificate",
    value: function applyTaxCertificate() {
      var _this4 = this;
      if (this.applyTaxCertificateForm.$valid) {
        var request = {
          customerId: this.state.currentCustomer.Id,
          request: {
            AccountNumber: this.accountNumber,
            AdjustmentTypeCode: NOTE_TYPES.CREDIT,
            Amount: parseFloat(this.taxAmount).toFixed(2),
            Description: this.noteDescription,
            GenerateStatement: this.enableGenerateStatements,
            DebitNoteId: null,
            InvoiceId: this.selectedInvoiceNumber && this.selectedInvoiceNumber.id || null,
            PostDate: new Date(),
            ReasonCode: this.selectedReasonCode,
            TaxCertificateDate: this.taxCertificateDate,
            TaxCertificateId: this.taxCertificateNumber
          }
        };
        this.actions.createConvergentBillerAdjustment(request).then(function () {
          _this4.uiNotificationService.transientSuccess(i18n.translate(LocaleKeys.APPLY_TAX_CERTIFICATE.APPLY_TAX_CERTIFICATE_SUCCESS));
          _this4.onSuccess();
        }).catch(function (error) {
          if (_this4.formErrorMessages) {
            _this4.formErrorMessages.length = 0;
          }
          _this4.formErrorMessages.push(error.translatedMessage);
        });
      } else {
        this.validateForm();
      }
    }
  }]);
}();
export default {
  controller: ApplyTaxCertificateModalController,
  controllerAs: 'ApplyTaxCertificateModalController',
  template: require('./applyTaxCertificate.modal.html'),
  bindings: {
    accountNumber: '<?',
    invoiceNumber: '<?',
    invoiceId: '<?',
    config: '<',
    onClose: '&',
    onSuccess: '&'
  }
};